// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"360":"6059d4e5","405":"abc01225","427":"52f25edb","643":"4b0a9cc8","780":"6eca54de","930":"125b45c2"}[chunkId] + ".css";
};